// extracted by mini-css-extract-plugin
module.exports = {"fileDropzone":"fileDropzone_fileDropzone__1o1_2","content":"fileDropzone_content__2CN4r","images":"fileDropzone_images__3LnbD"};